var React = require('react');

function CaretInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.75781 1.4375L6.00045 5.68014L10.2431 1.4375","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CaretInline.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"};

module.exports = CaretInline;

CaretInline.default = CaretInline;
